import deployment from './deployment.svg';
import design from './design.svg';
import development from './development.svg';
import documents from './documents.svg';

export default {
    sections: [
        {
            title: 'Design',
            text: 'we work with your needs to design solutions that fit your requirements and budget',
            image: 'design'
        }, {
            title: 'Development',
            text: "Through continual improvement, we help to develop solutions to help your business achieve it's goals",
            image: 'development'
        }, {
            title: 'Deployment',
            text: "Through our experience, planning and up to date skillsets we are able to deploy your solutions in your time frames and budget.",
            image: 'deployment'
        }, {
            title: "Documentation",
            text: "MIT services has a history of providing the very highest quality of documentation to our clients, in both the private and public sector.",
            image: 'documents'
        }
    ],
    components: {
        deployment,
        design,
        development,
        documents
    }
}